import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetChurnQuery } from '../../data/queries/get-churn.query'
import { type ChurnResponse } from '../models/churn'
import { DataType } from '../models/mrr'
import type { Resolution } from '../models/range'

export class GetChurnInteractor {
  constructor(private readonly getChurn: GetInteractor<ChurnResponse>) {}

  public async execute(
    fromDate: string,
    toDate: string,
    resolution: Resolution,
    dataType: DataType,
    organization: string
  ): Promise<ChurnResponse> {
    const apiDataType = dataType === DataType.Economics ? 'economics' : 'users'
    return await this.getChurn.execute(new GetChurnQuery(fromDate, toDate, resolution, apiDataType, organization))
  }
}
